<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faInstagram, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';

export default {
    name: "SocialMedia",
    created() {
        library.add(faFacebookF, faInstagram, faLinkedinIn, faYoutube);
    }
}
</script>

<template>
    <div class="flex space-x-4 md:space-x-2 justify-center xl:justify-start">
        <a class="flex items-center justify-center aspect-1/1 rounded h-8 w-8 text-base text-leonard-white hover:text-leonard-white-hover"
           target="_blank" rel="noopener noreferrer" title="Leonard's Official Facebook Page"
           href="https://www.facebook.com/LeonardsPhotography">
            <font-awesome-icon :icon="['fab', 'facebook-f']" aria-label="Facebook Icon"></font-awesome-icon>
        </a>
        <a class="flex items-center justify-center aspect-1/1 rounded h-8 w-8 text-base text-leonard-white hover:text-leonard-white-hover"
           target="_blank" rel="noopener noreferrer" title="Leonard's Official Instagram Page"
           href="https://www.instagram.com/leonards_photo/">
            <font-awesome-icon :icon="['fab', 'instagram']" aria-label="Instagram Icon"></font-awesome-icon>
        </a>
        <a class="flex items-center justify-center aspect-1/1 rounded h-8 w-8 text-base text-leonard-white hover:text-leonard-white-hover"
           target="_blank" rel="noopener noreferrer" title="Leonard's Official LinkedIn Page"
           href="https://www.linkedin.com/company/leonard%27s">
            <font-awesome-icon :icon="['fab', 'linkedin-in']" aria-label="LinkedIn Icon"></font-awesome-icon>
        </a>
        <a class="flex items-center justify-center aspect-1/1 rounded h-8 w-8 text-base text-leonard-white hover:text-leonard-white-hover"
           target="_blank" rel="noopener noreferrer" title="Leonard's Official YouTube Page"
           href="https://www.youtube.com/channel/UCN19uCo0kGO9gRC1dtZFdhg">
            <font-awesome-icon :icon="['fab', 'youtube']" aria-label="YouTube Icon"></font-awesome-icon>
        </a>
    </div>
</template>
